import * as React from 'react'
import styled from 'styled-components'
import List, {ListProps} from '@mui/material/List'

const ListAtom = styled((props: ListProps) => <List {...props} />)``

export default ListAtom
